module.exports = __webpack_public_path__ + "media/bgm_107.37cc00a7.m4a";